<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="TOC"><a href="#/Preface">Preface</a></p>
<p class="TOC"><a href="#/Prologue">Prologue: The View from the Barn</a></p>
<p class="TOC1"><a href="#/Chapter1">Katy Comes to Texas</a></p>
<p class="TOC"><a href="#/Chapter2">The Not-So-Gay Nineties</a></p>
<p class="TOC"><span href="#/Chapter3" title="Link target outside of Sample">Workin’ on the Railroad</span></p>
<p class="TOC"><span href="#/Chapter4" title="Link target outside of Sample">Railroad Wreck Made to Order</span></p>
<p class="TOC"><span href="#/Chapter5" title="Link target outside of Sample">A Man with a Very Apropos Name</span></p>
<p class="TOC"><span href="#/Chapter6" title="Link target outside of Sample">The Sincerest Form of Flattery</span></p>
<p class="TOC"><span href="#/Chapter7" title="Link target outside of Sample">Building Steam</span></p>
<p class="TOC"><span href="#/Chapter8" title="Link target outside of Sample">“The Most Novel Experiment Ever Given in Texas”</span></p>
<p class="TOC"><span href="#/Chapter9" title="Link target outside of Sample">“A Scene that Will Haunt a Man”</span></p>
<p class="TOC"><span href="#/Chapter10" title="Link target outside of Sample">Picking Up the Pieces</span></p>
<p class="TOC"><span href="#/Chapter11" title="Link target outside of Sample">The Photographers</span></p>
<p class="TOC"><span href="#/Chapter12" title="Link target outside of Sample">Litigation Ahead</span></p>
<p class="TOC"><span href="#/Chapter13" title="Link target outside of Sample">The King of Ragtime</span></p>
<p class="TOC"><span href="#/Chapter14" title="Link target outside of Sample">The Show Goes On…and On</span></p>
<p class="TOC1"><span href="#/Epilogue" title="Link target outside of Sample">Epilogue: End of the Line</span></p>
<p class="TOC"><span href="#/Appendix" title="Link target outside of Sample">Appendix: Known Staged Locomotive Crashes in the United States</span></p>
<p class="TOC"><span href="#/Sourcenote" title="Link target outside of Sample">Source Notes</span></p>
<p class="TOC"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="TOC"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?6ffa4d23